class DatosJuicio {
    constructor(juicio, denuncia, caratula, nombreCompleto, idLetradoCia, nroSiniestro, estadoJuicio, descripcion,patologia, capitalDeman, porcionRecla, jusrisdiccion, tipo, estudioExt, ibm) {
        this.juicio = juicio
        this.denuncia = denuncia
        this.caratula = caratula
        this.nombreCompleto = nombreCompleto
        this.idLetradoCia = idLetradoCia
        this.nroSiniestro = nroSiniestro
        this.estadoJuicio = estadoJuicio
        this.patologia = patologia
        this.descripcion = descripcion
        this.capitalDeman = capitalDeman
        this.porcionRecla = porcionRecla
        this.jusrisdiccion = jusrisdiccion
        this.tipo = tipo
        this.estudioExt = estudioExt
        this.ibm = ibm
    }
}

export default DatosJuicio